module.exports = __webpack_public_path__ + "static/img/icon_service_provider.5fb67300.svg";